import store from '@/store';
import { isMobileLayout } from '@/utils/mobile-detection';

const isMobileView = () => isMobileLayout() || store.getters['CommonStore/isMobileApp'];

const redirectWhenPulseIsHome = (to, from, next) => {
  const pulseIsHome = !isMobileView() && store.getters['BusinessStore/featureFlagsLoaded']
    && store.getters['BusinessStore/hasFeature']('pkg.ai.bizai_pulse')
    && store.getters['BusinessStore/hasFeature']('rollout.ai.bizai_pulse');
  if (pulseIsHome) {
    next({ name: 'home' });
  } else {
    next();
  }
};

const routes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "DashboardPage" */ './views/DashboardPage.vue'),
    props: { featureFlag: 'new_dashboard', angularRoute: 'app.dashboard' },
    meta: { i18n: 'dashboard-pov', pageNameEn: 'Dashboard' },
    beforeEnter: redirectWhenPulseIsHome,
  },
];

export default routes;
